import { Component, OnChanges, Input, ViewChild } from '@angular/core';
import { MSCDayToken, MaterialShortage } from '../../shared/misc-classes';
import { DataService } from '../../shared/dataservice.service';
import { GenService } from '../../shared/gen-ser.service';

@Component({
  selector: 'app-mtrl-shrtge',
  templateUrl: './mtrl-shrtge.component.html',
  styleUrls: ['./mtrl-shrtge.component.css']
})
export class MtrlShrtgeComponent implements OnChanges {
  @Input() currMonthDtObj:Date;
  @Input() mtrlShrtge:MaterialShortage;  
  dMSCDayTokenObj:MSCDayToken;

  constructor(private _dataService:DataService) { }

  ngOnChanges() {
    this.loadDateData();
  }
  loadDateData():void{
    if(this.mtrlShrtge){
      let _tmpMSCDayToken:MSCDayToken = this.mtrlShrtge.getDateToken(this.currMonthDtObj);
      if(_tmpMSCDayToken == null){
        this.mtrlShrtge.addDateToken(this.currMonthDtObj);  
        _tmpMSCDayToken = this.mtrlShrtge.getDateToken(this.currMonthDtObj);
      }
      this.dMSCDayTokenObj = _tmpMSCDayToken;
    }
    else{
      this.dMSCDayTokenObj = new MSCDayToken(this.currMonthDtObj,[])
    }
  }
  getParticulars(_par:string):string{
    if(_par){
      return _par
    }
    return ''
  }
  
  getOwner(_ownr:string):string{
    if(_ownr){
      return this._dataService.getResponsiblePrsn(_ownr);
    }
    return ''
  }
  formatDate(_date:Date):string{
    if(_date){
      return GenService.getDateFormatStr(_date, "DD/MMM/YY HH:mm:ss");
    }
    return '-';
  }

}
